import { render, staticRenderFns } from "./InventoryCalendar.vue?vue&type=template&id=b265ac7c"
import script from "./InventoryCalendar.vue?vue&type=script&lang=js"
export * from "./InventoryCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports